module.exports = __webpack_public_path__ + "img/otto-avatar-logo.a72989d9.svg";